import _ from 'lodash';
import { styled } from '@mui/material/styles';
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Stack,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { SvgChevronRightFill } from '../SvgIcons';
import { useActiveLink } from '../../hooks/useActiveLink';


export const SimMenusBar = styled((props) => (
  <Stack
    spacing={1.5}
    {...props}
  />
))(({ theme }) => ({
}));


// export const SimMenuColumns = styled('div')(({ theme }) => ({
//   display: 'grid',
//   gap: 48,
//   position: 'relative',
//   [theme.breakpoints.up('md')]: {
//     gridTemplateColumns: '240px auto',
//   },
//   [theme.breakpoints.down('md')]: {
//     gridTemplateRows: '1fr',
//   },
//   [theme.breakpoints.down('sm')]: {
//     gridTemplateRows: '1fr',
//   }
// }));

export const SimMenuColumns = withStyles((theme) => ({
  root: {
    display: 'grid',
    gap: 48,
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '240px auto',
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateRows: '1fr',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateRows: '1fr',
    }
  },
}))(({ classes, sidebar, children }) => {
  return (
    <div className={classes?.root}>
      { sidebar }
      { children }
    </div>
  )
});

export const SimMenuItem = styled((props) => <MenuItem disableGutters disableRipple {...props} />)(
  ({ theme }) => ({
    ...theme.typography.subtitle1,
    ...theme.typography.hoverPrimaryLeftline2px,
    padding: '12px 16px 12px 12px',
    maxWidth: '100%',
    minHeight: 48,
    borderBottom: '1px solid #CCC',
    fontWeight: 700,
    justifyContent: 'space-between',
    alignItems: 'center',
    overflow: 'visible',
    color: theme.palette.text.primary,
    textAlign: 'left',
    wordBreak: 'break-word',
    marginBottom: `0px !important`,
    '&.MuiButtonBase-root': {
      transition: 'all 0.5s',
      '& svg': { opacity: 0, transition: 'all 0.5s', flexBasis: 'auto', flexShrink: 0, flexGrow: 0 },
      '&:hover': {
        borderColor: 'transparent',
        color: theme.palette.action.selected,
        backgroundColor: theme.palette.action.hover,
        '& svg': { opacity: 1 },
      }
    },
    '&.Mui-selected': {
      borderColor: 'transparent',
      color: theme.palette.action.selected,
      backgroundColor: theme.palette.action.hover,
      '& svg': { opacity: 1 },
      '&:after': {
        width: '100%',
      },
    },
    '& .MuiListItemIcon-root': {
      minWidth: 16,
      justifyContent: 'flex-end',
    }
  }),
);
export const SimMenus = ({ list = [], onClick, selectedIndex }) => {
  return (
    <Paper sx={{ width: 320, maxWidth: '100%' }}>
      <MenuList disablePadding disableListWrap>
        {
          _.map(list, (item, index) => {
            return (
              <SimMenuItem
                key={index}
                selected={item?.path === selectedIndex}
                onClick={() => onClick(item)}
              >
                <ListItemText disableTypography>{ item?.title }</ListItemText>
                <ListItemIcon>
                  <SvgChevronRightFill />
                </ListItemIcon>
              </SimMenuItem>
            )
          })
        }
      </MenuList>
    </Paper>
  )
}


export const SimGlobalMenus = ({ list = [], onClick, selectedIndex }) => {
  return (
    <Paper sx={{ width: 320, maxWidth: '100%' }}>
      <MenuList disablePadding disableListWrap>
        {
          _.map(list, (item, index) => {
            const { id, label, props } = item || {};
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const active = useActiveLink(props?.path);
            return (
              <SimMenuItem
                key={index}
                selected={active}
                onClick={() => onClick(item)}
              >
                <ListItemText disableTypography>{ label }</ListItemText>
                <ListItemIcon>
                  <SvgChevronRightFill />
                </ListItemIcon>
              </SimMenuItem>
            )
          })
        }
      </MenuList>
    </Paper>
  )
}

export const SimExtendMenus = ({ list = [], onClick, selectedIndex }) => {
  return (
    <Paper sx={{ width: 320, maxWidth: '100%' }}>
      <MenuList disablePadding disableListWrap>
        {
          _.map(list, (item, index) => {
            const { label, contentCode, props } = item || {};
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const active = useActiveLink(props?.path);
            return (
              <SimMenuItem
                key={index}
                selected={active}
                // component={RouterLink}
                // to={`/honhai/service/${contentCode}`}
                onClick={() => onClick(item)}
              >
                <ListItemText disableTypography>{ label }</ListItemText>
                <ListItemIcon>
                  <SvgChevronRightFill />
                </ListItemIcon>
              </SimMenuItem>
            )
          })
        }
      </MenuList>
    </Paper>
  )
}
